import React from 'react';
import cx from 'classnames';
import styles from './Main.module.scss';

const Main = (props) => {
  const {
    className,
    children,
    type
  } = props;

  return (
    <main
      className={cx(styles.main, {
        [styles[className]]: !!className,
      })}
    >
      <div
        className={cx(styles.main__container, {
          [styles[`main__container--${type}`]]: !!type,
        })}
      >
        {children}
      </div>
    </main>
  );
};

Main.defaultProps = {
  type: 'type-1',
};

export default Main;
